import { IOrder, ILocationOrder, ISearchFilter } from '../state/orders';
import uniqBy from 'lodash-es/uniqBy';
import { isOrderListCloumnChange } from '@telstra-connect/utils/activity-tracking/common';

export function filterOrders(originalOrders: IOrder[], filters: ISearchFilter): IOrder[] {
  let filterdActiveOrders = originalOrders;

  if (filters && filters.location && filters.location.length) {
    filterdActiveOrders = filterdActiveOrders
      .filter((l) => (filters.location.filter((s) =>
      (l.filterLocation.filter((fl) => s.value === fl.value).length)
      )).length);
  }

  if (filters && filters.productName && filters.productName.length) {
    filterdActiveOrders = filterdActiveOrders
      .filter((l) => (filters.productName.filter((s) =>
        (l.products.filter((fl) => s.value === fl.name).length)
      )).length);
  }

  if (filters && filters.status && filters.status.length) {
    filterdActiveOrders = filterdActiveOrders
      .filter((l) => (filters.status.filter((s) => l.status === s.value)
      ).length);
  }

  return filterdActiveOrders;
}

export function filterLocationOrders(originalOrders: ILocationOrder[], filters: ISearchFilter): ILocationOrder[] {
  let filterdActiveOrders = originalOrders;

  if (filters && filters.location && filters.location.length) {
    filterdActiveOrders = filterdActiveOrders
      .filter((l) => (filters.location.filter((s) => l.location.replace(/  +/g, ' ').includes(s.value))
      ).length);
  }

  if (filters && filters.productName && filters.productName.length) {
    filterdActiveOrders = filterdActiveOrders
      .filter((l) => (filters.productName.filter((s) => l.name === s.value)
      ).length);
  }

  if (filters && filters.status && filters.status.length) {
    filterdActiveOrders = filterdActiveOrders
      .filter((l) => (filters.status.filter((s) => l.productStatus === s.value)
      ).length);
  }

  return filterdActiveOrders;
}

export function searchOrders(originalOrders: IOrder[], searchStringParam: string,
  isInternationalUser: boolean): IOrder[] {
  const searchActiveOrders = originalOrders;
  const searchString = searchStringParam.toLowerCase();

  const searchActiveNumberOrders = searchActiveOrders.filter((e) => e.number &&
    e.number.toLowerCase().includes(searchString))
  const searchActiveNcpOrders = searchActiveOrders.filter((e) => e.ncp && e.ncp.toLowerCase().includes(searchString));
  const searchActiveNameOrders = searchActiveOrders.filter((e) => e.name &&
    e.name.toLowerCase().includes(searchString))
  const searchActiveFilterLocationOrders = searchActiveOrders.filter((e) => e.filterLocation.filter((v) =>
    (v.value.toLowerCase().includes(searchString))).length);
  const searchActiveStatusOrders = searchActiveOrders.filter((e) => e.status &&
    e.status.toLowerCase().includes(searchString));
  const searchActiveSitesCompleteOrders = searchActiveOrders.filter((e) => e.sitesComplete &&
    e.sitesComplete.toLowerCase().includes(searchString));
  const searchActiveEstimatedOrders = searchActiveOrders.filter((e) =>
    e.estimatedDelivery && e.estimatedDelivery.toLowerCase().includes(searchString));
  const searchActiveFullfilledOrders = searchActiveOrders.filter((e) =>
    e.closedDate && e.closedDate.toLowerCase().includes(searchString));
  const searchActiveRequiredOrders = searchActiveOrders.filter((e) =>
    e.requiredDelivery && e.requiredDelivery.toLowerCase().includes(searchString));
  const searchActiveCustomerName = searchActiveOrders.filter((e) =>
    e.customerName && e.customerName.toLowerCase().includes(searchString));
  const searchActiveCustomerId = searchActiveOrders.filter((e) =>
    e.cidn && e.cidn.toLowerCase().includes(searchString));
  const searchYourReference = searchActiveOrders.filter((e) =>
    e.yourReference && e.yourReference.toLowerCase().includes(searchString));
  const searchProjectManager = searchActiveOrders.filter((e) =>
    e.projectManager && e.projectManager.toLowerCase().includes(searchString));

  let ordersArray = [...searchActiveNumberOrders, ...searchActiveNcpOrders, ...searchYourReference,
    ...searchActiveNameOrders, ...searchActiveFilterLocationOrders, ...searchActiveStatusOrders,
    ...searchActiveSitesCompleteOrders, ...searchActiveEstimatedOrders, ...searchActiveFullfilledOrders,
    ...searchProjectManager, ...searchActiveCustomerName, ...searchActiveCustomerId];

  if (!isOrderListCloumnChange(isInternationalUser)) {
    ordersArray = [...ordersArray, ...searchActiveRequiredOrders];
  }

  const orders = uniqBy(ordersArray, (v) => v.number);

  return orders;
}

export function searchLocationOrders(
  originalOrders: ILocationOrder[],
  searchStringParam: string, isInternationalUser?: boolean): ILocationOrder[] {
  const searchActiveOrders = originalOrders;
  const searchString = searchStringParam.toLowerCase();

  const searchActiveNumberOrders = searchActiveOrders.filter((e) => e.number &&
    e.number.toLowerCase().includes(searchString))
  const searchActiveNcpOrders = searchActiveOrders.filter((e) => e.ncp && e.ncp.toLowerCase().includes(searchString));
  const searchActiveNameOrders = searchActiveOrders.filter((e) => e.name &&
    e.name.toLowerCase().includes(searchString));
  const searchActiveProductTypeOrders = searchActiveOrders.filter((e) => e.productType &&
    e.productType.toLowerCase().includes(searchString));
  const searchActiveServiceIdOrders = searchActiveOrders.filter((e) => e.serviceId &&
    e.serviceId.toLowerCase().includes(searchString));
  const searchActiveStatusOrders = searchActiveOrders.filter((e) => e.productStatus &&
    e.productStatus.toLowerCase().includes(searchString));
  const searchActiveLocationOrders = searchActiveOrders.filter((e) => e.location &&
    e.location.toLowerCase().includes(searchString));
  const searchActiveSiteNameOrders = searchActiveOrders.filter((e) => e.siteName &&
    e.siteName.toLowerCase().includes(searchString));
  const searchActiveEstimatedOrders = searchActiveOrders.filter((e) => e.productEstimatedDelivery &&
    e.productEstimatedDelivery.toLowerCase().includes(searchString));
  const searchActiveFullfilledOrders = searchActiveOrders.filter((e) => e.productClosedDate &&
    e.productClosedDate.toLowerCase().includes(searchString));
  const searchActiveRequiredOrders = searchActiveOrders.filter((e) => e.productRequiredDelivery &&
    e.productRequiredDelivery.toLowerCase().includes(searchString));
  const searchupcomingAppointment = searchActiveOrders.filter((e) => e.upcomingAppointment &&
    e.upcomingAppointment.toLowerCase().includes(searchString));
  const searchActiveBilling = searchActiveOrders.filter((e) => e.billing &&
    e.billing.toLowerCase().includes(searchString));
  const searchYourReference = searchActiveOrders.filter((e) =>
    e.yourReference && e.yourReference.toLowerCase().includes(searchString));
  const searchActiveCustomerName = searchActiveOrders.filter((e) =>
    e.customerName && e.customerName.toLowerCase().includes(searchString));
  const searchActiveCustomerId = searchActiveOrders.filter((e) =>
    e.cidn && e.cidn.toLowerCase().includes(searchString));

  let ordersArray = [...searchActiveNumberOrders, ...searchActiveNcpOrders, ...searchActiveNameOrders,
    ...searchActiveBilling, ...searchActiveServiceIdOrders, ...searchYourReference,
    ...searchActiveLocationOrders, ...searchActiveStatusOrders, ...searchupcomingAppointment,
    ...searchActiveEstimatedOrders, ...searchActiveFullfilledOrders, ...searchActiveCustomerName,
    ...searchActiveCustomerId, ...searchActiveProductTypeOrders, ...searchActiveSiteNameOrders]

  if (!isOrderListCloumnChange(isInternationalUser)) {
    ordersArray = [...ordersArray, ...searchActiveRequiredOrders];
  }
  const orders = uniqBy(ordersArray,
  (v) => v.id);

  return orders;
}
